<template>
  <v-container grid-list-lg fluid px-0 py-0 my-0 mx-0 fill-height>
    <v-layout row wrap modal__block>
      <span class="modal__close" @click="closeModal"></span>
      <v-flex modal__wrapper xs12 :class="{ isBlocked: !editMode }">
        <v-form ref="form" v-model="valid">
          <v-layout form__row row wrap v-if="editMode">
            <v-flex xs12 text-left>
              <h1>{{ create ? $t("components.client.add.owner.add") : $t("components.client.add.owner.update") }}</h1>
            </v-flex>
            <v-flex xs12 py-0>
              <v-divider />
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap v-else>
            <v-flex xs12 text-left>
              <h1>{{$t("components.client.add.owner.title")}}</h1>
            </v-flex>
            <v-flex xs12 py-0>
              <v-divider />
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap>
            <v-flex v-if="create">
              <v-radio-group
                v-model="owner.is_legal_person"
                row
                :rules="rules.is_legal_person"
                :disabled="packageMode && !editMode"
                required
              >
                <v-radio :label="$t('components.client.add.owner.individual')" :value="false"></v-radio>
                <v-radio :label="$t('components.client.add.owner.company')" :value="true"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex shrink>
              <v-text-field
                v-model="owner.percentage"
                :label="$t('components.client.add.owner.percent')"
                :rules="create ? rules.percentageCreate : rules.percentage"
                :hint="create ? '' : $t('components.client.add.owner.maxPercent', {'per': maxPercentage})"
                type="number"
                suffix="%"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap v-if="owner.is_legal_person === false">
            <v-flex xs4 sm4 md4>
              <v-text-field
                v-model="owner.surname"
                :label="$t('components.client.add.owner.surname')"
                :rules="rules.surname"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs4 sm4 md4>
              <v-text-field
                v-model="owner.name"
                :label="$t('components.client.add.owner.name')"
                :rules="rules.name"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs4 sm4 md4>
              <v-text-field
                v-model="owner.patronymic"
                :label="$t('components.client.add.owner.patronymic')"
                :rules="rules.patronymic"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap v-if="owner.is_legal_person">
            <v-flex shrink>
              <v-text-field
                v-model="innOgrn"
                :label="$t('components.client.add.owner.innOgrn')"
                :hint="$t('components.client.add.owner.innOgrnHint')"
                :disabled="packageMode && !editMode"
                persistent-hint
              ></v-text-field>
            </v-flex>
            <v-flex shrink>
              <v-btn
                @click="getCompanyByInnOgrn"
                :disabled="!innOgrn"
                class="mt-3"
              >
                <v-icon>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap v-if="owner.is_legal_person">
            <v-flex xs8>
              <v-text-field
                v-model="owner.legal_person_name"
                :label="$t('components.client.add.owner.personName')"
                :rules="rules.legal_person_name"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                v-model="owner.legal_person_inn"
                :label="$t('components.client.add.owner.inn')"
                :rules="rules.legal_person_inn"
                :error-messages="errorMessages.legal_person_inn"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap v-if="owner.is_legal_person == false">
            <v-flex xs12>
              <v-text-field
                v-model="owner.inn"
                :label="$t('components.client.add.owner.inn')"
                :rules="rules.inn"
                :error-messages="errorMessages.inn"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap v-if="owner.is_legal_person">
            <v-flex xs12>
              <v-text-field
                v-model="owner.legal_person_kpp"
                :label="$t('components.client.add.owner.kpp')"
                :rules="rules.legal_person_kpp"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap v-if="owner.is_legal_person">
            <v-flex xs12>
              <v-text-field
                v-model="owner.legal_person_ogrn"
                :label="$t('components.client.add.owner.ogrn')"
                :rules="rules.legal_person_ogrn"
                :error-messages="errorMessages.legal_person_ogrn"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap v-if="owner.is_legal_person">
            <v-flex xs12>
              <v-text-field
                v-model="owner.legal_person_location"
                :label="$t('components.client.add.owner.location')"
                :rules="rules.legal_person_location"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap v-if="owner.is_legal_person">
            <v-flex xs12>
              <v-text-field
                v-model="owner.legal_general_director"
                :label="$t('components.client.add.owner.director')"
                :rules="rules.legal_general_director"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap v-if="owner.is_legal_person">
            <v-flex xs12>
              <v-text-field
                v-model="owner.legal_phone"
                :label="$t('inputs.phone.name')"
                v-mask="'(###) ###-##-##'"
                prefix="+7 "
                :rules="rules.legal_phone"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap v-if="owner.is_legal_person === false">
            <v-flex xs12>
              <v-autocomplete
                v-model="owner.document_type"
                :items="documentTypes"
                :label="$t('components.client.add.owner.documentType')"
                item-text="name"
                item-value="value"
                :rules="rules.document_type"
                :disabled="packageMode && !editMode"
                required
              ></v-autocomplete>
            </v-flex>
          </v-layout>

          <v-layout
            form__row
            row
            wrap
            v-if="owner.is_legal_person === false && owner.document_type === 1"
          >
            <v-flex xs4 sm4 md4>
              <v-text-field
                v-model="owner.document_seria"
                :label="$t('components.client.add.owner.serial')"
                :rules="rules.document_seria"
                :disabled="packageMode && !editMode"
                v-mask="'## ##'"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs8 sm8 md8>
              <v-text-field
                v-model="owner.document_number"
                :label="$t('components.client.add.owner.number')"
                :rules="rules.document_number"
                :disabled="packageMode && !editMode"
                v-mask="'### ###'"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout
            form__row
            row
            wrap
            v-if="owner.is_legal_person === false && owner.document_type == 1"
          >
            <v-flex xs6 sm6 md6>
              <v-menu
                ref="document_issued_at"
                v-model="documentIssuedAt"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="document_issued_at"
                    :label="$t('components.client.add.owner.issued_at')"
                    prepend-icon="event"
                    v-on="on"
                    v-on:blur="formatDocumentIssuedAt"
                    :rules="rules.document_issued_at"
                    v-mask="'##.##.####'"
                    :disabled="packageMode && !editMode"
                    return-masked-value
                    required
                  ></v-text-field>
                </template>
                <v-date-picker
                  ref="picker"
                  v-model="owner.document_issued_at"
                  :max="new Date().toISOString().substr(0, 10)"
                  min="1900-01-01"
                  @change="saveDocumentIssuedAt"
                  llocale="ru-ru"
                  first-day-of-week="1"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs6 sm6 md6>
              <v-text-field
                v-model="owner.document_subdivision_code"
                :label="$t('components.client.add.owner.issued_at')"
                :rules="rules.document_subdivision_code"
                v-mask="'###-###'"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout
            form__row
            row
            wrap
            v-if="owner.is_legal_person === false && owner.document_type == 1"
          >
            <v-flex xs12>
              <v-text-field
                v-model="owner.document_issued_by"
                :label="$t('components.client.add.owner.issuedBy')"
                :hint="$t('components.client.add.owner.strictlyPassport')"
                :rules="rules.document_issued_by"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap v-if="owner.is_legal_person === false">
            <v-flex xs12>
              <v-text-field
                v-model="owner.document_reg_address"
                :hint="$t('components.client.add.owner.strictlyPassport')"
                :label="$t('components.client.add.owner.regAddress')"
                :disabled="packageMode && !editMode"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout
            form__row
            row
            wrap
            v-if="owner.is_legal_person === false && owner.document_type == 2"
          >
            <v-flex xs12>
              <v-text-field
                v-model="owner.document_other_data"
                :label="$t('components.client.add.owner.ohterData')"
                :rules="rules.document_other_data"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap v-if="owner.is_legal_person === false">
            <v-flex xs6 sm6 md6>
              <v-menu
                ref="day_of_birth"
                v-model="dayOfBirth"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="day_of_birth"
                    :label="$t('components.client.add.owner.birthday')"
                    prepend-icon="event"
                    v-on="on"
                    v-on:blur="formatDayOfBirth"
                    :rules="rules.day_of_birth"
                    v-mask="'##.##.####'"
                    :disabled="packageMode && !editMode"
                    return-masked-value
                    required
                  ></v-text-field>
                </template>
                <v-date-picker
                  ref="picker"
                  v-model="owner.day_of_birth"
                  :max="new Date().toISOString().substr(0, 10)"
                  min="1900-01-01"
                  @change="saveDayOfBirth"
                  locale="ru-ru"
                  first-day-of-week="1"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs6 sm6 md6>
              <v-text-field
                v-model="owner.place_of_birth"
                :label="$t('components.client.add.owner.placeOfBirth')"
                :rules="rules.place_of_birth"
                :hint="$t('components.client.add.owner.strictlyPassport')"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout
            form__row
            row
            wrap
            v-if="owner.is_legal_person === false && owner.document_type == 1"
          >
            <v-flex xs12>
              <v-text-field
                v-model="owner.snils"
                :label="$t('components.client.add.owner.snils')"
                :error-messages="errorMessages.snils"
                v-mask="'###-###-### ##'"
                :disabled="packageMode && !editMode"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap v-if="owner.is_legal_person === false">
            <v-flex xs12>
              <v-text-field
                v-model="owner.phone"
                :label="$t('inputs.phone.name')"
                prefix="+7 "
                v-mask="'(###) ###-##-##'"
                :rules="rules.phone"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap v-if="owner.is_legal_person === false">
            <v-flex xs12>
              <v-autocomplete
                v-model="owner.citizenship"
                :items="citizenshipTypes"
                :label="$t('components.client.add.owner.citizenship')"
                item-text="name"
                item-value="value"
                :rules="rules.citizenship"
                :disabled="packageMode && !editMode"
                required
              ></v-autocomplete>
            </v-flex>
          </v-layout>

          <v-layout form__row form__errors row wrap v-if="errors">
            <v-flex xs12>
              {{$t('components.client.add.owner.checkErrors')}}:
              <strong v-for="(error, idx) in errors" :key="`error_f${idx}`">{{
                error
              }}</strong>
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap v-if="editMode || !packageMode">
            <v-flex xs12>
              <v-btn :loading="ownerSaveLoading" :disabled="ownerSaveLoading" @click="validate" color="primary"
                >{{ create ? $t('components.client.add.owner.saveOwner') : $t('components.client.add.owner.updateOwner') }}</v-btn
              >
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { apiCallTrue } from "@/utils/api";
import rules from "@/utils/data/rules";
import { mask } from "vue-the-mask";
import OwnerModel from "@/models/OwnerModel";
import showNotify from "@/services/noty";

import i18n from "@/services/i18n";

export default {
  name: "AddOwner",
  directives: { mask },
  data: () => ({
    valid: false,
    errors: null,
    errorMessages: {
      snils: "",
      inn: "",
      legal_person_inn: "",
      legal_person_ogrn: "",
    },
    newErrorMessages: {
      snils: "",
      inn: "",
      legal_person_inn: "",
      legal_person_ogrn: "",
    },
    owner: {},
    ownerSaveLoading: false,
    newOwner: {
      percentage: "",
      is_legal_person: null,
      legal_person_name: "",
      legal_person_inn: "",
      legal_person_kpp: "",
      legal_person_ogrn: "",
      legal_person_location: "",
      legal_general_director: "",
      legal_phone: "",
      surname: "",
      name: "",
      patronymic: "",
      inn: "",
      snils: "", // 13849173290
      phone: "",
      document_type: "",
      document_seria: "",
      document_number: "",
      document_issued_at: null,
      document_subdivision_code: "",
      document_issued_by: "",
      document_reg_address: "",
      document_other_data: "",
      day_of_birth: null,
      place_of_birth: "",
      citizenship: "",
    },
    innOgrn: "",
    dayOfBirth: false,
    day_of_birth: "",
    documentIssuedAt: false,
    document_issued_at: "",
    documentTypes: [
      { name: i18n.t("documentTypes.1"), value: 1 },
      { name: i18n.t("documentTypes.2"), value: 2 },
    ],
    citizenshipTypes: [
      { name: i18n.t("citizenshipTypes.643"), value: "643" },
      { divider: true },
      { name: i18n.t("citizenshipTypes.895"), value: "895" },
      //{ name: i18n.t("citizenshipTypes.010"), value: "010" },
      { name: i18n.t("citizenshipTypes.051"), value: "051" },
      { name: i18n.t("citizenshipTypes.112"), value: "112" },
      { name: i18n.t("citizenshipTypes.398"), value: "398" },
      { name: i18n.t("citizenshipTypes.417"), value: "417" },
      { name: i18n.t("citizenshipTypes.762"), value: "762" },
      { name: i18n.t("citizenshipTypes.860"), value: "860" },
      { name: i18n.t("citizenshipTypes.804"), value: "804" },
      { name: i18n.t("citizenshipTypes.896"), value: "896" },
    ],
    rules,
  }),
  props: {
    publicHash: {
      type: String,
      default: "",
    },
    maxPercentage: {
      type: Number,
      default: 0,
    },
    editedOwner: {
      type: Object,
    },
    create: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: true,
    },
    packageMode: {
      type: Boolean,
      default: false,
    },
    agentMode: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.saveOwner();
      }
    },
    async saveOwner() {
      const method = "POST";
      const data = Object.assign({}, this.owner);
      data.snils = data.snils ? data.snils
        .replace("-", "")
        .replace("-", "")
        .replace(" ", "") : null;
      const inn = this.agentMode ? this.agentMode : false;
      this.ownerSaveLoading = true;

      if (this.packageMode) {
        let url = "";
        if (this.publicHash) {
          url = this.create
            ? `v1/founders/save-by-hash/${this.publicHash}`
            : `v1/founders/${this.owner.id}/save-by-hash/${this.publicHash}`;
        } else {
          url = "v1/validate";
        }
        const params = this.publicHash ? null : { model: "founders", inn };
        await apiCallTrue({
          url,
          data,
          method,
          params,
        })
          .then((response) => {
            // this.updateOwners(response);
            // this.errors = null;
            // this.errorMessages = Object.assign(
            //     {},
            //     this.newErrorMessages
            // );

            if (this.create) {
              this.addOwner(response.data.data);
            } else {
              this.updateOwners(response.data.data);
            }
          })
          .catch((error) => {
            this.errors = error.validation;
            this.errorMessages = this.errors ? this.errors : {};
            showNotify("error", error);
          })
          .finally(() => {
            this.ownerSaveLoading = false;
          });
      } else {
        const url = this.create
          ? "v1/founders"
          : `v1/founders/${this.owner.id}`;
        const params = inn ? { inn } : {};

        await apiCallTrue({
          url,
          data,
          method,
          params,
        })
          .then((response) => {
            this.updateOwners(response, method);
            this.errors = null;
            this.errorMessages = Object.assign({}, this.newErrorMessages);
          })
          .catch((error) => {
            this.errors = error.validation;
            this.errorMessages = this.errors ? this.errors : {};
            showNotify("error", error);
          })
          .finally(() => {
            this.ownerSaveLoading = false;
          });
      }
    },
    updateOwners(owner) {
      this.$emit("updateOwners", owner);
    },
    addOwner(owner) {
      this.$emit("addOwner", owner);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    saveDayOfBirth(date) {
      this.$refs.day_of_birth.save(date);
      this.deFormatDayOfBirth();
    },
    formatDayOfBirth() {
      if (this.day_of_birth) {
        this.owner.day_of_birth = this.day_of_birth
          .split(".")
          .reverse()
          .join("-");
      }
    },
    deFormatDayOfBirth() {
      if (this.owner.day_of_birth) {
        this.day_of_birth = this.owner.day_of_birth
          .split("-")
          .reverse()
          .join(".");
      }
    },
    saveDocumentIssuedAt(date) {
      this.$refs.document_issued_at.save(date);
      this.deFormatDocumentIssuedAt();
    },
    formatDocumentIssuedAt() {
      if (this.document_issued_at) {
        this.owner.document_issued_at = this.document_issued_at
          .split(".")
          .reverse()
          .join("-");
      }
    },
    deFormatDocumentIssuedAt() {
      if (this.owner.document_issued_at) {
        this.document_issued_at = this.owner.document_issued_at
          .split("-")
          .reverse()
          .join(".");
      }
    },
    async getCompanyByInnOgrn() {
      await apiCallTrue({
        url: `v1/autocomplete/organization/${this.innOgrn}`,
      }).then((response) => this.fillCompanyData(response.data.data.data));
    },
    fillCompanyData(data) {
      //console.log(data, "daaaataaaaa");
      this.owner.legal_person_name = data.name.full_with_opf;
      this.owner.legal_person_inn = data.inn;
      this.owner.legal_person_kpp = data.kpp;
      this.owner.legal_person_ogrn = data.ogrn;
      this.owner.legal_person_location = data.address.value;
      this.owner.legal_general_director = data.management.name;
    },
    closeModal() {
      this.$emit("closeModal");
    },
  },
  watch: {
    create(val) {
      if (!val) {
        this.owner = Object.assign({}, this.editedOwner);
        this.deFormatDayOfBirth();
        this.deFormatDocumentIssuedAt();
      } else {
        this.day_of_birth = "";
        this.document_issued_at = "";

        this.owner = new OwnerModel();

        this.errors = null;
        this.errorMessages = Object.assign({}, this.newErrorMessages);
        this.$refs.form.resetValidation();
      }
    },
    dayOfBirth(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    documentIssuedAt(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  mounted() {
    if (this.create) {
      this.owner = new OwnerModel();
    } else {
      this.owner = Object.assign({}, this.editedOwner);
      this.deFormatDayOfBirth();
      this.deFormatDocumentIssuedAt();
    }
    this.$refs.form.resetValidation();
  },
};
</script>
<style lang="scss">
</style>
